var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"md:mb-8 lg:mb-16"},[_c('categories'),_c('items-header'),_c('items',{attrs:{"load-more-button":_vm.loadMoreButton}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }